import { connect } from 'react-redux';
import { selectActiveModal } from './Modal.selectors';
import { closeModal } from './Modal.reducers';
import Modal from './Modal';

const mapStateToProps = (state, ownProps) => {
  const { modalName, modalProps } = selectActiveModal(state, ownProps);
  return {
    modalName,
    modalProps,
  };
};

const mapDispatchToProps = { closeModal };

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
